import { render, staticRenderFns } from "./QueensLab2NotebookCheck.vue?vue&type=template&id=181fdb5a&scoped=true&"
import script from "./QueensLab2NotebookCheck.vue?vue&type=script&lang=ts&"
export * from "./QueensLab2NotebookCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181fdb5a",
  null
  
)

export default component.exports